export const translateSecurityIssues = (i18n) => ({
  /* i18n-block-start except: ["en"] */
  securityProblem: i18n.gettext('Tengo un problema de seguridad'),
  /* i18n-block-end */
});
